<ng-template #dashOptionsModal>
  <div [style.fontSize]="fontSizes[dashFontSize]">
    <h5>
      Dash Modules
      <br>
      <span class="text-muted small">Drag to desired order</span>
    </h5>
    <div [sortablejs]="dashBaseConfs" [sortablejsOptions]="dashReSortOptions">
      <div *ngFor="let d of dashBaseConfs; let i = index">
        <div class="dashModuleMock" [style.border-color]="d.boxMainColor">
          <div class="row dashTitleMock Starbase-Title-Font" [style.color]="d.boxMainColor">
            <i [class]="'fa-fw fal ' + dashIcons[i]"></i>
            {{ d.boxTitle }}
          </div>
        </div>
        <i class="fal fa-lg fa-grip-horizontal ms-2 grabHandle" matTooltip="Drag to reorder the dash modules" libHoverColor="black"></i>
      </div>
    </div>
    <hr>
    <h5>Dashboard Theme</h5>
    <div class="row" style="margin-left: 0; margin-right: 0;">
      <div class="col-4" *ngFor="let t of availableThemes">
        <div class="card">
          <div [class]="'card-body themeCard text-center ' + t.class" [ngClass]="{'active': theme.name === t.name}" (click)="switchTheme(t)">
            <div class="card-title">{{ t.name }}</div>
          </div>
        </div>
      </div>
    </div>
    <hr>
    <h5>Dashboard Font Size
      <br>
      <span class="text-muted small">Affects entire dashboard and all dash modules</span>
    </h5>
    <div aria-label="Dashboard font size controls" class="btn-group" role="group">
      <button class="btn" [ngClass]="{'btn-link': dashFontSize === 1, 'btn-outline-secondary': dashFontSize !== 1}" matTooltip="Extra small font size" type="button"
      (click)="setDashFontSize(1)">
        <i class="fal fa-xs fa-text-size fa-flip-horizontal"></i>
      </button>
      <button class="btn" [ngClass]="{'btn-link': dashFontSize === 2, 'btn-outline-secondary': dashFontSize !== 2}" matTooltip="Small font size" type="button"
      (click)="setDashFontSize(2)">
        <i class="fal fa-sm fa-text-size fa-flip-horizontal"></i>
      </button>
      <button class="btn" [ngClass]="{'btn-link': dashFontSize === 3, 'btn-outline-secondary': dashFontSize !== 3}" matTooltip="Medium (default) font size" type="button"
      (click)="setDashFontSize(3)">
        <i class="fal fa-text"></i>
      </button>
      <button class="btn" [ngClass]="{'btn-link': dashFontSize === 4, 'btn-outline-secondary': dashFontSize !== 4}" matTooltip="Large font size" type="button"
      (click)="setDashFontSize(4)">
        <i class="fal fa-lg fa-text-size"></i>
      </button>
      <button class="btn" [ngClass]="{'btn-link': dashFontSize === 5, 'btn-outline-secondary': dashFontSize !== 5}" matTooltip="Extra large font size" type="button"
      (click)="setDashFontSize(5)">
        <i class="fal fa-2x fa-text-size"></i>
      </button>
    </div>
    <br>
  </div>
</ng-template>

<ng-template #ctAssignModal>
  <div *ngIf="!(contactSvc.contactTypeDataStore$ | async).length; else massCTLoaded">
    Please wait...
  </div>
  <ng-template #massCTLoaded>
    <p>
      Ready to adjust {{ massContactsUIDs.length }} Contact records.
    </p>
    <label for="ctDropupMenu" class="form-label">
      Choose multiple
    </label>
    <div class="btn-group dropdown ms-1">
      <button type="button" id="ctDropupMenu" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
        class="btn btn-sm dropdown-toggle"
        [ngClass]="{'btn-dark': darkMode, 'btn-light': glassMode, 'btn-outline-secondary': !darkMode && !glassMode}">
        Contact Types
      </button>
      <div class="dropdown-menu" style="max-height: 200px; overflow: auto;" aria-labelledby="ctDropupMenu">
        <a class="dropdown-item" *ngFor="let ctd of (contactSvc.contactTypeDataStore$ | async)" (click)="toggleObjectInArray(massCTs, ctd)">
          <i class="fal fa-check me-1" *ngIf="massCTs.includes(ctd)"></i>
          <span class="contactTypeBadge" [libContactTypeBadge]="ctd.color" [deletable]="false">
            {{ ctd.contactTypeDescription }}
          </span>
        </a>
      </div>
    </div>
    <label class="form-label">
      to {{ massCTRemoveMode ? 'remove' : 'add' }}.
    </label>
    <hr class="mt-3">
    <h6 *ngIf="massCTs.length">When you press Save, {{ massCTs.length }} <em>Contact Type(s)</em> will be {{ massCTRemoveMode ? 'removed from' : 'added to' }} each chosen <em>Contact</em>.</h6>
  </ng-template>
</ng-template>

<ng-template #newContactModal>
  <div class="form-row">
    <div class="form-inline form-group">
      <label>This contact will be &nbsp;</label>
      <div class="btn-group btn-group-sm btn-group-toggle" data-bs-toggle="buttons">
        <label for="orgToggle" class="btn btn-sm btn-light"
          [ngClass]="{'active': contactPaneHandle.singlePaneData.individual, 'inactive': !contactPaneHandle.singlePaneData.individual}"
          (click)="singleContactPaneData.individual = true"><i class="fal fa-user"></i>&nbsp;an Individual
          <input type="radio" required name="orgToggle" autocomplete="off" id="orgToggle" [value]="true"
            [(ngModel)]="contactPaneHandle.singlePaneData.individual" />
        </label>
        <label for="orgToggle2" class="btn btn-sm btn-light"
          [ngClass]="{'active': !contactPaneHandle.singlePaneData.individual, 'inactive': contactPaneHandle.singlePaneData.individual}"
          (click)="singleContactPaneData.individual = false">an Organization&nbsp;<i class="fal fa-briefcase"></i>
          <input type="radio" required name="orgToggle" id="orgToggle2" autocomplete="off" [value]="false"
            [(ngModel)]="contactPaneHandle.singlePaneData.individual" />
        </label>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #sendEmailModal>
  <p>
    To: <span class="badge badge-pill" [matTooltip]="sendingEmailAddress">{{ sendingEmailAddress.includes(',') ? sendingEmailAddress.split(',').length + ' recipients' : sendingEmailAddress }}</span>
    <br>
    Subject: <input type="text" #subjectForEmail placeholder="Enter a subject line" class="form-control">
    <br>
    <textarea id="textForEmail" #textForEmail class="form-control emailForm" name="textForEmail" placeholder="Type your message"></textarea><br>
  </p>
</ng-template>

<nav class="sideBarNav">
  <div class="sideBarTopBtn"   matTooltip="Scroll to top" [libHoverColor]="theme.name === 'Plain' ? '#6590a7' : theme.color" (click)="scrollToMenu()">
    <i class="fal fa-fw fa-arrow-to-top"></i>
  </div>
  <div class="sideBarBtnSection">
    <div class="sideBarBtn" [style.border-color]="theme.name === 'Plain' ? '#6590a7' : theme.color" *ngFor="let dm of dashBaseConfs; let i = index" [matTooltip]="dm.boxTitle" matTooltipPosition="right" [libHoverColor]="dm.boxMainColor" (click)="focusOnDash(i)">
      <i class="fal fa-lg fa-fw" [ngClass]="dm.dashConf.boxMainIconClass"></i>
    </div>
  </div>
  <div class="sideBarBottomBtn" matTooltip="Dashboard settings" [libHoverColor]="theme.color" (click)="openDashOptions()">
    <i class="fal fa-lg fa-cog"></i>
  </div>
</nav>

<main [class]="'mb-4 dashWrapper ' + theme.class"
 [style.color]="theme.secondaryColor ? theme.secondaryColor : theme.color"
 [ngStyle]="{'fontSize': fontSizes[dashFontSize]}">
  <lib-dashboard #mainDashboard *ngIf="booted"
    [user]="displayName"
    [modules]="dashModules"
    [confs]="dashBaseConfs"
    [timeZoneOffset]="(userTimeZone$ | async).DSToffset"
    (messageEmitter)="sbCmpMsgSvc.handleStarbaseComponentMsg($event)"
    (UIDQueueArrayEmitter)="updateUIDQueues($event)"
    (openRecordEmitter)="openRecord($event)"
    (newRecordEmitter)="newRecordHandler($event)"
    (saveDashConfEmitter)="updateDashConfs($event)"
    (sendMessageEmitter)="interceptMessageCommand($event)"
    [darkMode]="appGlobalSvc.getStoredDarkModeSetting()"
    [glassMode]="appGlobalSvc.getStoredGlassModeSetting()">
  </lib-dashboard>

  <div class="dashPaneSlide" [style.width]="contactPaneHandle.fullScreenMode ? '100%' : '900px'" [ngClass]="{'open': contactPaneHandle.isPaneOpen, 'fullScreen': contactPaneHandle.fullScreenMode}" [style.border-color]="contactPaneHandle.accentColor">
    <lib-contactPane #contactPane *ngIf="contactPaneHandle.isPaneOpen"
      [open]="contactPaneHandle.isPaneOpen"
      [theRecord]="contactPaneHandle.singlePaneData"
      [accentColor]="contactDashModule.boxMainColor"
      [contactTypeData]="nonProtectedContactTypes"
      [navTabsOverride]="contactPaneTabs"
      [isAdmin]="isAdmin()"
      [defaultBackgroundImgPath]="'../../assets/11th%20OVC%20Logo%203x3.png'"
      [defaultIndividualAvatarPath]="'../../assets/11th%20OVC%20Logo%203x3.png'"
      [defaultOrganizationAvatarPath]="'../../assets/11th%20OVC%20Logo%203x3.png'"
      [mainDataService]="contactSvc"
      [recordUIDQueue]="getUIDQueueForModule(contactDashModule.dashConf.boxTitle)"
      [userAccountDataService]="userSvc"
      (editUserEmitter)="contactSvc.openUserAccount($event.uid)"
      (closePaneEmitter)="closePanes()"
      (createUserEmitter)="promoteContactToUser($event)"
      (deleteUserEmitter)="handleDeleteUser($event)"
      (shareDataEmitter)="handleShareContact($event)"
      (changingUIDEmitter)="updateActiveContactUID($event)"
      (messageEmitter)="sbCmpMsgSvc.handleStarbaseComponentMsg($event)"
      (deleteDataEmitter)="deleteContact(contactPaneHandle.singlePaneData)"
      (deactivateConfirmEmitter)="deactivateContactConfirm($event)"
      [fullScreenMode]="contactPaneHandle.fullScreenMode"
      (fullScreenModeEmitter)="contactPaneHandle.toggleFullScreen($event)"
      (requestStarbaseRecordEmitter)="closePanes(); openRecord($event)"
      (requestRecordHistoryEmitter)="handleRecordHistoryRequest($event)"
      [fileUploadDescription]="'1920x1080 pixels max. 18MB max. Accepts .jpg .png .gif .tif'"
      [timeZoneOffset]="(userTimeZone$ | async).DSToffset"
      (recordUpdatedEmitter)="contactUpdated()"
      (updateConfirmEmitter)="contactUpdateConfirm($event)"
      [webSocketSvc]="webSocketSvc"
      (sendMessageEmitter)="receiveSendMessage($event)">
      <ng-container ngProjectAs="contactPhones">
        <div class="ms-4">
          <lib-new-table-editor #contactPhonesTable modelName="Contact Phone"
            (messageEmitter)="sbCmpMsgSvc.handleStarbaseComponentMsg($event)"
            (deleteConfirmEmitter)="sbCmpMsgSvc.dataDeleteConfirm($event)"
            [tooltipDelay]="tooltipDelay"
            [usePagination]="false"
            [loadAllClientside]="true"
            [dataSvc]="contactPhoneSvc"
            [columns]="contactPhoneCols"
            [userViewOptions]="contactPaneTableViewOpts">
            <ng-template #rowTemplate let-rowData="rowData" let-columnDefinitions="contactPhoneCols" let-editRow="editRow" let-compactMode="compactMode" let-columnDividers="columnDividers">
              <span style="display: contents;" lib-table-row
                [rowData]="rowData"
                [columnDefinitions]="contactPhoneCols"
                [editRow]="editRow"
                [allowEdit]="true"
                [compactMode]="compactMode"
                [showColumnDividers]="columnDividers"
                (cancelEmitter)="contactPhonesTable.cancelChanges($event)"
                (selectedEmitter)="contactPhonesTable.changeEditMode(!editRow, rowData.uid)"
                (deleteEmitter)="contactPhonesTable.deleteRecordPressed($event)"
                (saveEmitter)="contactPhonesTable.saveChanges($event)"></span>
            </ng-template>
          </lib-new-table-editor>
        </div>
      </ng-container>
      <ng-container ngProjectAs="contactEmails">
        <div class="ms-4">
          <lib-new-table-editor #contactEmailsTable modelName="Contact Email"
            (messageEmitter)="sbCmpMsgSvc.handleStarbaseComponentMsg($event)"
            (deleteConfirmEmitter)="sbCmpMsgSvc.dataDeleteConfirm($event)"
            [tooltipDelay]="tooltipDelay"
            [usePagination]="false"
            [loadAllClientside]="true"
            [dataSvc]="contactEmailSvc"
            [columns]="contactEmailCols"
            [userViewOptions]="contactPaneTableViewOpts">
             <ng-template #rowTemplate let-rowData="rowData" let-columnDefinitions="contactEmailCols" let-editRow="editRow" let-compactMode="compactMode" let-columnDividers="columnDividers">
                <span style="display: contents;" lib-table-row
                  [rowData]="rowData"
                  [columnDefinitions]="contactEmailCols"
                  [editRow]="editRow"
                  [allowEdit]="true"
                  [compactMode]="compactMode"
                  [showColumnDividers]="columnDividers"
                  (cancelEmitter)="contactEmailsTable.cancelChanges($event)"
                  (selectedEmitter)="contactEmailsTable.changeEditMode(!editRow, rowData.uid)"
                  (deleteEmitter)="contactEmailsTable.deleteRecordPressed($event)"
                  (saveEmitter)="contactEmailsTable.saveChanges($event)"></span>
             </ng-template>
          </lib-new-table-editor>
        </div>
      </ng-container>
    </lib-contactPane>
  </div>
  <div class="dashPaneSlide" style="width: 900px;" [ngClass]="{'open': transactionPaneHandle.isPaneOpen}" [style.border-color]="transactionPaneHandle.accentColor">
    <lib-transaction-pane #transactionPane *ngIf="transactionPaneHandle.isPaneOpen"
    [open]="transactionPaneHandle.isPaneOpen"
    [theRecord]="transactionPaneHandle.singlePaneData"
    [accentColor]="transactionPaneHandle.accentColor"
    [isAdmin]="transactionPaneHandle.adminSession"
    [mainDataService]="transactionPaneHandle.dataService"
    [timeZoneOffset]="(userTimeZone$ | async).DSToffset"
    [recordUIDQueue]="getUIDQueueForModule(transLogDashModule.boxTitle)"
    (manageUserEmitter)="contactSvc.openUserAccount($event.uid)"
    (requestRecordHistoryEmitter)="handleRecordHistoryRequest($event)"
    (messageEmitter)="sbCmpMsgSvc.handleStarbaseComponentMsg($event)"
    (closePaneEmitter)="closePanes()">

    </lib-transaction-pane>
  </div>

  <app-create-sb-user-wrapper *ngIf="createWizOpen" class="wizards"
    [minimumPwdLength]="appGlobalSvc.minimumPwdLength"
    [minimumPwdScore]="appGlobalSvc.minimumPwdScore"
    [passwordScorerFn]="score"
    [userGroups]="userGroups"
    [emailTakenFn]="checkEmailTaken"
    [optionalContactModel]="promoteContact"
    [subscriptionBasedApp]="true"
    (wizardCompletedEmitter)="handleCreateWizardCompleted($event)"
    (wizardCancelledEmitter)="handleCreateWizardCancelled()">
      <i class="fal fa-user-plus me-1"></i> Create a new Research Arsenal user
  </app-create-sb-user-wrapper>
  <app-create-contact-wizard-wrapper *ngIf="newContactWizOpen" class="wizards"
  [contactTypes]="nonProtectedContactTypes"
   (wizardCompletedEmitter)="handleCreateContactWizard($event)"
   (wizardSoftCompletionEmitter)="handleCreateContactWizard($event, true)"
   (wizardCancelledEmitter)="handleCreateWizardCancelled()">
    <i [class]="'fal me-1 ' + contactDashModule.addNewIconClass" [style.color]="contactDashModule.boxMainColor"></i> Create a new Contact
  </app-create-contact-wizard-wrapper>
  <br>
</main>

<div *ngIf="this.activeUsers" class="activeUsersDiv">
  <span style="margin: auto; padding: 0 1em;">{{this.activeUsers}} Active Users</span>
</div>

<!--<div class="helpDiv">
  <button type="button" class="btn helpButton" (click)="toggleHelp()">
    <i [class]="'fal fa-xl ' + (!helpOpen ? 'fa-question' : 'fa-angle-down')"></i>
  </button>
</div>

<div *ngIf="helpOpen" class="helpModal">
  <h2 class="helpHeader"><i class="fal fa-lg fa-question-circle"></i> Help</h2>
  <br>
  <h4 class="helpQuestion">I just created a subscription, but I don't see any transactions?</h4>
  <h4 class="helpAnswer">The Fortis payment system processes performs subscription payments at 6:00 AM Eastern Time. So when a new subscription is created the next payment is not processed until the next day.</h4>
  <br>
  <h4 class="helpQuestion">I just created a new subscription, now i can't cancel that subscription?</h4>
  <h4 class="helpAnswer">Since Payments for new subscriptions aren't processed until the next day Users can't cancel their subscription until the initial payment has been processed. If the subscription was in error Admins have the ability to cancel the subscription before the payment processes.</h4>
</div>-->

<ng-template #expDateCol let-contact>
  <td class="recordVal">
    {{ contact.userAccount?.subscriptionExpiryDate | date : 'shortDate' }}
  </td>
</ng-template>
<ng-template #expDateColHeader>
  <th class="boxHeader">Renew/Exp.</th>
</ng-template>
